// extracted by mini-css-extract-plugin
export default {"backgroundContainer":"ModalWindow_backgroundContainer__-dsho","container":"ModalWindow_container__xt16j","closeButton":"ModalWindow_closeButton__R1kz4"};